import { createContext, useContext } from 'react';
export const NotificationsContext = createContext({});
export const NotificationsHandlerContext = createContext({
    acknowledge() { },
    change() { },
    refresh() { },
});
export function useNotificationsHandler() {
    return useContext(NotificationsHandlerContext);
}
export function useNotifications() {
    return useContext(NotificationsContext);
}
//# sourceMappingURL=notifications.js.map